// extracted by mini-css-extract-plugin
export default {"root":"CoursewareModal_root__wyPbf","body":"CoursewareModal_body__GB0Vi","container":"CoursewareModal_container__Wz2CG","main":"CoursewareModal_main__AqGXU"};